// action - state management
import * as actionTypes from './actions';

export const initialState = {
    initial: true,
    isLoading: false,
    ocrText: null,
    error: null
};

// ===========================|| CUSTOMIZATION REDUCER ||=========================== //

const ocrReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OCR_IMAGE_START:
            return {
                ...state,
                initial: false,
                isLoading: true
            };
        case actionTypes.OCR_IMAGE_START_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ocrText: action.data,
                error: null,
                initial: false
            };
        case actionTypes.OCR_IMAGE_START_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.error,
                ocrText: null,
                initial: false
            };
        case actionTypes.OCR_IMAGE_CLEAR:
            return initialState;
        default:
            return state;
    }
};

export default ocrReducer;
